<div class="group-avatar-container">
  <capra-icon icon="icon-user-group"></capra-icon>
</div>
